import { AuthenticationService } from "../services/AuthenticationService";
class AuthUtils {
  public static getAuthenticatedInUser = async () => {
    let authenticationService: AuthenticationService = new AuthenticationService();
    let refreshTokenResponse = await authenticationService.refreshToken();
    if (refreshTokenResponse && refreshTokenResponse.loginDetails) {
      return refreshTokenResponse;
    }
    return {
      error: refreshTokenResponse.error,
      status: refreshTokenResponse.status,
      ok: refreshTokenResponse.ok,
    };
  };
  public static logout = async () => {
    let authenticationService: AuthenticationService = new AuthenticationService();
    let refreshTokenResponse = await authenticationService.logout();
    if (refreshTokenResponse) {
      return refreshTokenResponse;
    }
    return {
      error: refreshTokenResponse.error,
      status: refreshTokenResponse.status,
      ok: refreshTokenResponse.ok,
    };
  };


  public static getTokenExpirationDate(decoded: any): any {
    if (decoded.exp === undefined) return null;
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }
  public static getHeaders = (moreHeaders?: any) => {
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": window.location.host,
      "origin": `http://${window.location.host}`,
      app: "WEB",
      ...moreHeaders,
    };
    return headers;
  };
}
export default AuthUtils;
